import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { TopMenuType } from './HeaderType';
import stashearnLogo from '../../../utils/assests/logo-new.png';
import faqIcon from '../../../utils/assests/faq-icon.png';
import { useHistory, useLocation } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { logFirebaseEvent } from '../../../Pages/StashKar/firebase';
import {
  P2P_AMOUNT_SELECTION_BACK_BTN,
  P2P_BACK_BTN,
  P2P_HELP_BTN,
  P2P_HELP_ND_BTN,
} from '../../../Pages/StashKar/firebase/constant';
import { getSource } from '../../../utils/localStorage';
import { useDispatch } from 'react-redux';
import { getResetValue } from '../../../Pages/StashKar/InvestFund/investFundAction';
import { MdKeyboardBackspace } from 'react-icons/md';
import { HiDotsVertical } from 'react-icons/hi';
import Grid from '@mui/material/Grid';
import { iOSDeviceChecked } from '../../../utils/utils';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

function TopMenu(props: TopMenuType) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const open = Boolean(anchorEl);
  const { title, showMenuDot } = props;

  const [source, setSource] = useState<any>('');

  useEffect(() => {
    setSource(getSource('source'));
  }, []);

  const backRoute = () => {
    logFirebaseEvent(P2P_AMOUNT_SELECTION_BACK_BTN);
    logFirebaseEvent(P2P_BACK_BTN);
    if (location.pathname === '/p2p/investFund') dispatch(getResetValue());
    if (location.pathname !== '/p2p/dashboard') history.goBack();
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    window.localStorage.clear();
    history.push({
      pathname: '/',
    });
  };

  const handleFaq = () => {
    logFirebaseEvent(P2P_HELP_ND_BTN);
    logFirebaseEvent(P2P_HELP_BTN);
    history.push('/p2p/faq');
  };

  const handleLogo = () => {
    history.push('/p2p/dashboard');
  };
  return (
    <>
      {location.pathname === '/p2p/personalInfo' ||
      location.pathname === '/p2p/connectBank' ||
      location.pathname === '/p2p/lenderAgreement' ||
      location.pathname === '/p2p/personalInfoSecond' ? null : (
        <Box className='shortHeader'>
          <Grid container alignItems='center'>
            <Grid item xs={9} className='logoWithBackIcon'>
              {/* {
            location.pathname == '/p2p/payment-response' && <div className='text-color' onClick={() => handleGotoDashboard()}>go to dashboard</div>
          } */}
              {
                 !iOSDeviceChecked() &&
                location.pathname !== '/p2p/verifyOtp' &&
                location.pathname !== '/p2p/dashboard' &&
                location.pathname !== '/p2p/personalInfo' &&
                location.pathname !== '/p2p/connectBank' &&
                location.pathname !== '/p2p/lenderAgreement' && (
                  <MdKeyboardBackspace onClick={() => backRoute()} />
                )}
                {/* <div className='fix-logo-ios'> */}
                <img
                onClick={handleLogo}
                className={iOSDeviceChecked() ? 'mainLogo-ios' : 'mainLogo'}
                src={stashearnLogo}
                alt=''
              />
                {/* </div> */}
            </Grid>
            <Grid item xs={3}>
              {showMenuDot && (
                <Box className='faqAndOption'>
                  <img onClick={handleFaq} src={faqIcon} alt='' />
                  {source !== 'inApp' ? (
                    <>
                      <Button
                        aria-haspopup='true'
                        aria-expanded={open ? 'true' : undefined}
                        disableElevation
                        onClick={handleClick}
                        className='logOutBtn'
                      >
                        <HiDotsVertical />
                      </Button>
                      <StyledMenu
                        id='demo-customized-menu'
                        MenuListProps={{
                          'aria-labelledby': 'demo-customized-button',
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                      </StyledMenu>
                    </>
                  ) : (
                    ''
                  )}
                </Box>
              )}
            </Grid>
          </Grid>
          {/* <h6 className='fs-20 text-white fw-500 mt-10'>{title}</h6> */}
        </Box>
      )}
    </>
  );
}

export default TopMenu;
